(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  // Mobile menu
  $$('[data-menu-toggle]').forEach(btn => btn.addEventListener('click', () => {
    const header = btn.closest('.bl-header');
    const nav = $('.bl-nav-wrap', header);
    const open = nav?.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }));

  // Mobile dropdowns
  document.addEventListener('click', e => {
    if (window.innerWidth > 900) return;
    const item = e.target.closest('.bl-nav-item.has-dropdown');
    if (!item) return;
    const link = e.target.closest(':scope > a');
    if (!link) return;
    e.preventDefault();
    item.classList.toggle('is-open');
  });

  // Hero slider
  $$('[data-hero-slider]').forEach(slider => {
    const slides = $$('[data-hero-slide]', slider);
    const dots = $$('[data-hero-dot]', slider);
    if (slides.length < 2) return;
    let index = 0, timer;
    const show = i => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    };
    const restart = () => { clearInterval(timer); timer = setInterval(() => show(index + 1), 5500); };
    $('[data-hero-next]', slider)?.addEventListener('click', () => { show(index + 1); restart(); });
    $('[data-hero-prev]', slider)?.addEventListener('click', () => { show(index - 1); restart(); });
    dots.forEach(d => d.addEventListener('click', () => { show(Number(d.dataset.heroDot)); restart(); }));
    slider.addEventListener('mouseenter', () => clearInterval(timer));
    slider.addEventListener('mouseleave', restart);
    show(0); restart();
  });

  // Wishlist
  const wishlistKey = 'barbi3land_wishlist';
  const getWishlist = () => { try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch { return []; } };
  const saveWishlist = list => localStorage.setItem(wishlistKey, JSON.stringify(list));
  const syncWishlist = () => {
    const list = getWishlist();
    $$('[data-wishlist]').forEach(btn => {
      if (list.includes(btn.dataset.wishlist)) btn.classList.add('is-wishlisted');
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', () => {
        const current = getWishlist(), handle = btn.dataset.wishlist;
        const next = current.includes(handle) ? current.filter(x => x !== handle) : [...current, handle];
        saveWishlist(next); btn.classList.toggle('is-wishlisted', next.includes(handle));
      });
    });
  };
  syncWishlist();
  document.addEventListener('shopify:section:load', syncWishlist);

  // Cart drawer
  const drawer = $('[data-cart-drawer]');
  const formatMoney = cents => (cents / 100).toLocaleString('en-PK', { style: 'currency', currency: 'PKR' });
  const escapeHtml = s => String(s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
  async function refreshCart() {
    if (!drawer) return;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      const content = $('[data-cart-content]', drawer);
      if (!content) return;
      content.innerHTML = cart.items.length ? cart.items.map(item => `<div class="drawer-item"><img src="${item.image || ''}" alt=""><div><strong>${escapeHtml(item.product_title)}</strong><div>${formatMoney(item.final_line_price)}</div><small>Qty: ${item.quantity}</small></div></div>`).join('') : '<div class="empty-state"><p>Your cart is empty.</p></div>';
    } catch (err) { console.warn(err); }
  }
  const openCart = () => { drawer?.classList.add('is-open'); drawer?.setAttribute('aria-hidden','false'); refreshCart(); };
  const closeCart = () => { drawer?.classList.remove('is-open'); drawer?.setAttribute('aria-hidden','true'); };
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
  drawer?.addEventListener('click', e => { if (e.target.matches('[data-cart-overlay]')) closeCart(); });

  // Quick add
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    const button = $('button', form);
    if (!button || button.disabled) return;
    const original = button.textContent;
    button.disabled = true; button.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', { method:'POST', headers:{Accept:'application/json'}, body:new FormData(form) });
      if (!res.ok) throw new Error('Add failed');
      await refreshCart(); openCart();
    } catch { alert('Sorry, this item could not be added to your cart.'); }
    finally { button.disabled = false; button.textContent = original; }
  });

  // Product gallery
  $$('[data-product-thumb]').forEach(btn => btn.addEventListener('click', () => {
    const main = $('[data-product-main] img');
    if (!main) return;
    main.src = btn.dataset.productThumb;
    main.srcset = '';
  }));

  // Variant selector: update hidden variant id using product JSON embedded in page
  const productJson = $('[data-product-json]');
  if (productJson) {
    try {
      const product = JSON.parse(productJson.textContent);
      const selects = $$('[data-option-select]');
      const idInput = $('[data-variant-id]');
      const price = $('[data-product-price]');
      const findVariant = () => {
        const values = selects.map(s => s.value);
        return product.variants.find(v => v.options.every((o, i) => o === values[i]));
      };
      selects.forEach(s => s.addEventListener('change', () => {
        const variant = findVariant();
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (price) price.textContent = new Intl.NumberFormat('en-PK',{style:'currency',currency:'PKR'}).format(variant.price / 100);
      }));
    } catch (e) { console.warn('Variant data unavailable', e); }
  }

  // Collection sorting
  $('[data-sort]')?.addEventListener('change', e => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', e.target.value);
    location.href = url.toString();
  });
})();
